module.exports = __webpack_public_path__ + "img/date_coach.eaf03c4c.svg";